<template>
    <div>
        <div class="form-group">
            <input 
                type="text" 
                class="form-control" 
                :class="{grey: grey_background}"
                v-model="search" 
                :placeholder="placeholderAsData" 
                ref="input"
                @focus="show = true" 
                @blur="hideList" 
                @keyup.enter="selectManyItems" 
                style="text-indent: 14px;"
            >
            <font-awesome-icon icon="chevron-circle-down" class="d-down" :class="{grey: grey_background}" @click.stop="toggleList"/>
        </div>
        <div class="form-group position-relative">
            <ul class="list-group" v-if="show" id="list">
                <li class="list-group-item" v-for="li in filteredList" :key="li.id" @click.stop="selectItem(li)">
                    <label class="text-muted ml-1 align-middle hyphens-auto">
                        <font-awesome-icon class="mm-color" :icon="['far', 'check-square']" v-if="selectedItems.find(item => item.id == li.id)" style="font-size: 1.2rem"/>
                        <font-awesome-icon class="mm-color" :icon="['far', 'square']"       v-else style="font-size: 1.2rem"/>
                        <span v-for="(name, index) in shownAttribute" :key="name">
                            {{li[name]}}
                            <template v-if="shownAttribute.length != index + 1">
                                -
                            </template>
                        </span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filteredList: this.list,
                selectedItems: this.selected,
                placeholderAsData: this.placeholder,
                search: '',
                show: false,
                hide: true,
            }
        },
        props: {
            shownAttribute: {
                type: Array,
                required: false,
                default() {
                    return ['name'];
                }
            },
            selected: {
                type: Array,
                default() {
                    return []
                }
            },
            list: {
                type: Array,
                required: true
            },
            placeholder: {
                type: String,
                required: true
            },
            grey_background: {
                type: Boolean,
                required: false,
                default() {
                    return false
                }
            }
        },
        watch: {
            selected(val) {
                this.selectedItems = val;
                this.updatePlaceholder();
            },
            search(val) {
                if(val != '') {
                    this.show = true;
                }
                this.filteredList = this.list.filter(item => {
                    let check = false;
                    for (const attr of this.shownAttribute) {
                        check = check || item[attr].toLowerCase().includes(this.search.toLowerCase())
                        if(check) {
                            return check;
                        }
                    }
                    return check;
                });
            }
        },
        model: {
            prop: 'selected',
            event: 'select'
        },
        methods: {
            selectItem(item) {
                this.hide = false;
                this.$refs.input.focus();
                let found = this.selectedItems.find(el => el.id === item.id);

                if(found) {
                    this.selectedItems = this.selectedItems.filter(el => el.id != item.id);
                }else{
                    this.selectedItems.push(item);
                }
                
                // this.search = '';
                this.updatePlaceholder();
                this.$emit('select', this.selectedItems);
            },
            selectManyItems() {
                this.hide = false;
                this.$refs.input.focus();

                for (const item of this.filteredList) {
                    let found = this.selectedItems.find(el => el.id === item.id);
    
                    if(found) {
                        continue;
                    }else{
                        this.selectedItems.push(item);
                    }            
                }
                
                // this.search = '';
                this.updatePlaceholder();
                this.$emit('select', this.selectedItems);
            },
            hideList() {
                this.hide = true;
                setTimeout(() => {
                    if(this.hide){
                        this.show = false;
                    }
                }, 400);
            },
            toggleList() {
                this.show = !this.show;

                if(this.show){
                    this.$refs.input.focus();
                }
            },
            updatePlaceholder() {
                if(this.selectedItems.length > 0) {
                    this.placeholderAsData = this.selectedItems.reduce((prev, current) => current[this.shownAttribute[0]] + ', ' + prev, '');                   
                    this.placeholderAsData = this.placeholderAsData.slice(0, -2);
                }else {
                    this.placeholderAsData = this.placeholder;
                }
            }
        }
    }
</script>

<style scoped>
.d-down{
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
    font-size: 1.2rem;
    color: #5FA963;
    background-color: white;
}
.list-group{
    position: absolute;
    top: -20px;
    right: 0;
    left: 0;
    z-index: 10;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
}
.list-group-item{
    cursor: pointer;
    background-color: #fafafa; 
}
.hyphens-auto{
    hyphens: auto;
    word-break: break-all;
}
.grey{
    background-color: #d0d0d0 !important;
}
</style>